









import { Component, Vue, Prop, Watch } from 'nuxt-property-decorator'
import { Base64 } from 'js-base64'
import { reverseString } from '~/utils/CommonUtils'

const test = Base64.decode(reverseString('info@example.com'))

@Component({
  name: 'ObfuscatedEmail',
  components: {}
})
export default class extends Vue {
  @Prop({ default: test }) value

  timeoutToReversedText = 1000
  timeoutToHref = 2000
  reversedAccount = null
  reversedDomain = null
  href = null
  reversedDecodedEmail = null

  @Watch('value', { immediate: true })
  valueChanged() {
    this.prepare()
  }

  prepare() {
    setTimeout(() => {
      this.reversedDecodedEmail = Base64.decode(this.value)
      this.reversedAccount = this.reversedDecodedEmail.split('@')[1]
      this.reversedDomain = this.reversedDecodedEmail.split('@')[0]
    }, this.timeoutToReversedText)
    setTimeout(() => {
      const email = reverseString(this.reversedDecodedEmail)
      this.href = `mailto:${email}`
    }, this.timeoutToHref)
  }

  // TODO: timer destroy, mounted
}
